import { getDocs, collection, doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig"

export const getApplications = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'applications'));
    const data = querySnapshot.docs.map(doc => ({...doc.data(), id: doc.id }));

    return data;
  } catch (err) {
    console.log('Error at fetching applications: ', err);
  }
}

export const getApplication = async (id) => {
  try {
    const result = await getDoc(doc(db, 'applications', id));
    if (!result.data()) throw Error(`No application found with id: ${id}`);
  
    return result.data();
  } catch (err) {
    console.log(`Error at fetching application (${id}):`, err);
  }
}